import { getObjectData } from 'src/actions/objectActions';

export const REQUEST_OBJECT_VIEW = 'request_object_view';
export const RECEIVE_OBJECT_VIEW = 'receive_object_view';
export const OBJECT_VIEW_ERROR = 'object_view_error';

const getActiveObjectRedux = (modelId, guid) => async (dispatch) => {
	const onRequest = () => {
		// dipatch request string to be handled by reducer
		dispatch({
			type: REQUEST_OBJECT_VIEW,
		});
	};
	const onSuccess = (success) => {
		dispatch({
			// dipatch receive string and payload to be handled by reducer
			type: RECEIVE_OBJECT_VIEW,
			payload: success,
		});
		return success;
	};
	const onError = (error) => {
		dispatch({
			// dipatch error string and payload to be handled by reducer
			type: OBJECT_VIEW_ERROR,
			payload: error,
		});
	};
	try {
		onRequest();
		// make api call
		const data = await getObjectData(modelId, guid);
		return onSuccess(data);
	} catch (error) {
		console.log(error);
		return onError(error);
	}
};

export { getActiveObjectRedux };
